import styled from 'styled-components';
import { FC, useState } from 'react';
import { Tab, Tabs as MuiTabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Coupons } from './coupons';
import { DisplayRules } from './display-rules';
import { Integrations } from './integrations';
import { Publish } from './publish';

const TabSections = [
  {
    title: 'settingsNav.coupons',
    content: <Coupons />,
  },
  {
    title: 'settingsNav.displayRules',
    content: <DisplayRules />,
  },
  {
    title: 'settingsNav.integrations',
    content: <Integrations />,
  },
  {
    title: 'settingsNav.publish',
    content: <Publish />,
  },
];

export const CommonCampaignSettings: FC<{ editable: boolean }> = ({ editable }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();

  const handleTabChange = (_: any, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <SettingsWrapper>
      <Tabs orientation="vertical" value={activeTab} onChange={handleTabChange}>
        {Object.values(TabSections).map((section) => (
          <Tab label={t(section.title)} key={section.title} />
        ))}
      </Tabs>

      <TabContent>{TabSections[activeTab].content}</TabContent>

      {!editable && <FormDisabler />}
    </SettingsWrapper>
  );
};

const SettingsWrapper = styled.div`
  display: flex;
  max-width: 980px;
  margin-bottom: 36px;
  position: relative;
`;

const TabContent = styled.div`
  padding-left: 16px;
  width: 100%;
  min-height: 400px;
`;

const Tabs = styled(MuiTabs)`
  min-width: 160px;
  border-right: 1px solid #c1c1c1;

  button {
    align-items: flex-start;
    padding-left: 8px;
  }
`;

const FormDisabler = styled.div`
  position: absolute;
  inset: 0 0 0 0;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 10000000;
`;
